import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6f2d06b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navigation-icon elevation-1 rounded-circle d-flex justify-center align-center" }
const _hoisted_2 = ["xlink:href"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 2 }

import { computed } from "vue";
import { IconType } from "../types";

interface Props {
  icon: string;
}
const size = 25;

export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationIcon',
  props: {
    icon: {}
  },
  setup(__props: any) {

const props = __props;

const iconType = computed(() => {
  const iconValueLowercase = props.icon.toLowerCase();
  if (iconValueLowercase.endsWith(".svg")) return IconType.SVG;
  else if (iconValueLowercase.endsWith(".png") || iconValueLowercase.endsWith(".jpg")) return IconType.IMAGE;
  else return IconType.NONE;
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (iconType.value === _unref(IconType).SVG)
      ? (_openBlock(), _createElementBlock("svg", {
          key: 0,
          width: size,
          height: size
        }, [
          _createElementVNode("image", {
            "xlink:href": _ctx.icon,
            width: size,
            height: size
          }, null, 8, _hoisted_2)
        ]))
      : (iconType.value === _unref(IconType).IMAGE)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _ctx.icon,
              width: size,
              height: size,
              alt: ""
            }, null, 8, _hoisted_4)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_v_icon, { color: "#795de9" }, {
              default: _withCtx(() => [
                _createTextVNode("mdi-web")
              ]),
              _: 1
            })
          ]))
  ]))
}
}

})